import * as React from "react";
import { store } from "../../redux/store";
import { match } from "react-router-dom"; //needed for 'location' object and 'match.params'
import { connect } from "react-redux";
import { mapDispatchToProps, updateReduxAction } from "../../redux/actions";
import "../../css/FactoryRequests.scss";
import { getSelectedProject } from "../Project/ProjectUtilities";
import MultiSelectDropDown, { IOption } from "./MultiSelectDropDown";
import { getFactoryRequestEmailValidationMessage } from "./FactoryRequestUtility";
// expected props
interface IProps {
  updateRedux: any;
  reduxFactorySubmittalDetails:any;
  reduxProjectManagement:any;
  reduxFactoryRequestUnits:any;
  reduxFactoryRequest:any;
  match: match<any>;
  disableUI:boolean;
  purchaseOrderMissing:boolean;
  selectedUnitsMissing:boolean;
}
// local state
interface IState {
    emailError: string;
    currentEmail:string;
}

class SubmittalInputs extends React.Component<IProps, IState> {
  public state: IState = {
    emailError: "",
    currentEmail:"",
  };
  async componentDidMount() {
    const { projectId, unitId } = this.props.match.params;
    //Protect against refresh on this page.  Need to repopulate reduxProjectManagement if refresh occurs.
    if (!this.props.reduxProjectManagement.selectedProject){
      await getSelectedProject("proj-" + projectId);
    }
    const consultingEngineer = this.props.reduxProjectManagement?.selectedProject?.consultingEngineer ? 
    this.props.reduxProjectManagement.selectedProject.consultingEngineer : "";
    const contractor = this.props.reduxProjectManagement?.selectedProject?.contractor ? 
    this.props.reduxProjectManagement.selectedProject.contractor : "";
    const purchaseOrderNumber = this.props.reduxProjectManagement?.selectedProject?.purchaseOrderNumber ? 
    this.props.reduxProjectManagement.selectedProject.purchaseOrderNumber : "";
    this.prepopulateProjectInfoData(consultingEngineer, contractor, purchaseOrderNumber);
  }
  private prepopulateProjectInfoData(consultingEngineer:string, contractor:string, purchaseOrderNumber:string){
    const submittalDetails = this.props.reduxFactorySubmittalDetails;
    let submittalDetailsCopy = { ...submittalDetails };
    submittalDetailsCopy.submittalRequestDetails.ConsultingEngineer = consultingEngineer;
    submittalDetailsCopy.submittalRequestDetails.Contractor = contractor;
    submittalDetailsCopy.submittalRequestDetails.PurchaseOrderNumber = purchaseOrderNumber;

    this.props.updateRedux("UPDATE_SUBMITTAL_DETAILS", submittalDetailsCopy );
  }
  private getUnitOptions() {
    const unitOptions: IOption[] = this.props.reduxFactoryRequestUnits
      .filter((u: any) => u.isActive)   // only active units
      .map((u: any) => ({
        name: u.unitTag,
        value: u.id
      }));
  
    return unitOptions;
  }
  private handleUnitSelectionChange (id:number, selected:string[])  {
    const factoryRequest = this.props.reduxFactoryRequest;
    let factoryRequestCopy = { ...factoryRequest };
    factoryRequestCopy.factoryRequest["SelectedUnits"]= selected;
    this.props.updateRedux("UPDATE_FACTORY_REQUEST", factoryRequestCopy );
  }
  public render() {
    const invalidEmailClass = this.state.emailError ? "email-error" : "app-display-none";
    const unitOptions = this.getUnitOptions();
    const unitDropdownClass = this.props.disableUI ? "element-disable" : "";
    return (
      <div className="request-inputs">
          {/* UNITS */}
          <div className="units-dropdown-submittal">
            <label className="unit-label-submittal">Units *</label>
            <MultiSelectDropDown
                className={unitDropdownClass + (this.props.selectedUnitsMissing ? " input-required-error" : "")}
                options={unitOptions}
                onChange={(id:number, selected:string[]) => this.handleUnitSelectionChange(id, selected)}
                initialSelected={this.props.reduxFactoryRequest.factoryRequest?.SelectedUnits || []}
                modificationId={0}
                includeAll={true}
                titleText={"Select Unit to be included in the submittal"}
            /> 
          </div> 
          <div className="div-input">
            <label className="label-width">Purchase Order #  *</label>
            <input
                className={this.props.purchaseOrderMissing ? " input-required-error" : ""}
                type="text"
                value= {this.props.reduxFactorySubmittalDetails.submittalRequestDetails.PurchaseOrderNumber}
                onChange={(e) => this.updateReduxSubmittalInputs("PurchaseOrderNumber", e.currentTarget.value )}
            /> 
           </div>
           <div className="div-input"> 
                <label className="label-width">Consulting Engineer</label>
                <input
                    type="text"
                    value={this.props.reduxFactorySubmittalDetails.submittalRequestDetails.ConsultingEngineer}
                    onChange={(e) => this.updateReduxSubmittalInputs("ConsultingEngineer", e.currentTarget.value )}
                />
            </div>
            <div className="div-input"> 
                <label className="label-width">Contractor</label>
                <input
                    type="text"
                    value={this.props.reduxFactorySubmittalDetails.submittalRequestDetails.Contractor}
                    onChange={(e) => this.updateReduxSubmittalInputs("Contractor", e.currentTarget.value )}
                />
            </div>
        {/* ADDTIONAL EMAIL RECIPIENTS */}
        <div className="div-input">
          <label className="email-label">Additional Email Recipients:</label>
          <ul>
          {this.props.reduxFactorySubmittalDetails.submittalRequestDetails.AdditionalEmailRecipients?.map((email:string) => (
          <div key={email}>
            <li className="email-item"> {email}
            <button className="email-delete-button" onClick={() => this.handleRemoveEmail(email)}>
              ×
            </button>
            </li>
          </div>
          ))}
          </ul>
          <div>
            <input
              className="email-input"
              type="text"
              value={this.state.currentEmail}
              onChange={(e) => this.handleEmailChange(e.currentTarget.value)}
              placeholder="Enter email"
              onBlur={(e) => this.setState({emailError:""})}
            />
            <button onClick={this.handleAddEmail}>Add</button>
          </div>
          <div className={invalidEmailClass}>{this.state.emailError}</div>
        </div> 
      </div>
    );
  }
  private updateReduxSubmittalInputs(fieldName:string, value:any){
    const submittalDetails = this.props.reduxFactorySubmittalDetails;
    let submittalDetailsCopy = { ...submittalDetails };
    submittalDetailsCopy.submittalRequestDetails[fieldName]= value;
    this.props.updateRedux("UPDATE_SUBMITTAL_DETAILS", submittalDetailsCopy );
  }
  private handleEmailChange = (value:string) => {
    this.setState({currentEmail:value});
  }
  private handleAddEmail = () => {
    const email = this.state.currentEmail.trim();
    const emailValidationMessage = getFactoryRequestEmailValidationMessage(email);
    if (emailValidationMessage) {
      this.setState({emailError:emailValidationMessage});
      return;
    }
    let emails = this.props.reduxFactorySubmittalDetails.submittalRequestDetails.AdditionalEmailRecipients;
    let copyEmails = [...emails];
    copyEmails.push(email);
    this.updateReduxSubmittalInputs("AdditionalEmailRecipients", copyEmails);
    this.setState({currentEmail:"", emailError:""});
  }
  private handleRemoveEmail = (emailToRemove:string) => {
    let emails = this.props.reduxFactorySubmittalDetails.submittalRequestDetails.AdditionalEmailRecipients;
    let copyEmails = [...emails];
    this.updateReduxSubmittalInputs("AdditionalEmailRecipients", copyEmails.filter((email:string) => email !== emailToRemove));
  }
}
//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {
    reduxFactorySubmittalDetails: state.reduxFactorySubmittalDetails,
    reduxProjectManagement: state.reduxProjectManagement,
    reduxFactoryRequestUnits: state.reduxFactoryRequestUnits,
    reduxFactoryRequest: state.reduxFactoryRequest
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SubmittalInputs);
